import { useState, useEffect } from "react";

export const useModal = () => {
  const [isOpen, setIsOpen] = useState(false);
  const openModal = () => setIsOpen(true);
  const closeModal = () => setIsOpen(false);

  // Add and remove 'modal-open' class to body element to disable scrolling
  useEffect(() => {
    if (isOpen) {
      document.body.classList.add("modal-open");
    } else {
      document.body.classList.remove("modal-open");
    }

    // Cleaning effect when disassembling the component
    return () => {
      document.body.classList.remove("modal-open");
    };
  }, [isOpen]);

  return [isOpen, openModal, closeModal];
};
